import { useRef } from "react";
import { AppSelect } from "../components/inputs/AppSelect";
import { useLocale } from "../i18n";

export function RoundTeamLimit({ roleName, value, mode, frozen, onChange }: { roleName: string; value: number; mode?: string; frozen: boolean; onChange: (value: number, mode: string) => void }) {
  const { w } = useLocale(); const numeric = useRef(value); const all = mode === "ALL";
  return <div className="evaluation-team-limit">
    <AppSelect aria-label={w(`نوع الحد الأقصى ${roleName}`, `${roleName} team limit type`)} value={all ? "all" : "number"} onChange={next => {
      if (next === "all") { numeric.current = value; onChange(1, "ALL"); }
      else onChange(numeric.current, "NUMBER");
    }}>
      <option value="number">{w("عدد محدد", "Specific number")}</option>
      <option value="all">{w("كل الفرق المشاركة", "All participating teams")}</option>
    </AppSelect>
    {!all ? <input aria-label={w(`عدد أصوات ${roleName}`, `${roleName} vote allowance`)} type="number" required min={1} max={100} step={1} value={value} onChange={e => { numeric.current = Number(e.target.value); onChange(numeric.current, "NUMBER"); }} />
      : <p className="evaluation-all-count" role="status">{frozen ? w(`${value} فرق مشاركة`, `${value} participating teams`) : w("يشمل جميع الفرق المدرجة عند تجهيز الجولة", "Includes every team admitted when the round is prepared")}</p>}
    <small>{all ? w("يُثبَّت عدد الفرق الفعلي عند تجهيز الجولة، ضمن حدود الخدمة.", "The actual team count is frozen when the round is prepared, within service limits.") : w("لكل مقيّم في الجولة", "Per evaluator in this round")}</small>
  </div>;
}
